<div
    class="dropzone"
    [ngClass]="{
        dropzone__error: showErrorStyling
    }"
    (dragenter)="onDragenter()"
    (dragleave)="onDragleave($event)"
    data-testid="dropzone"
>
    <div class="dropzone__content">
        <ng-content></ng-content>
    </div>
</div>
